import React from 'react';
import { Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { PageNotFound } from '../../404';
import { FasitApmRoute } from '../../apm/fasit-apm-route';
import { useFeatureToggles } from '../../feature-toggles';
import { ForumCaseworkerPage } from './caseworker/forum-caseworker-page';
import { useCanReadCitizenDialog } from './caseworker/citizen-dialog-access';

export function ForumArea() {
  const match = useRouteMatch();
  const { isFeatureEnabled } = useFeatureToggles();
  const canReadCitizenDialog = useCanReadCitizenDialog();

  // Throwing here would latch the app-wide error boundary instead of just hiding the area.
  if (!isFeatureEnabled('EnableSagWebApex') || !canReadCitizenDialog) {
    return <PageNotFound />;
  }

  // Named so gated Forum traffic still shows up as its own APM transaction during rollout.
  return (
    <Switch>
      <FasitApmRoute path={match.path}>
        <ForumCaseworkerPage />
      </FasitApmRoute>
    </Switch>
  );
}
